<template>
  <span
    :class="`icon--${name}`"
    class="icon"/>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/fonts/iconfont';

$icon-names: home, booking, connect_ng, connect_ok, edit, login_setting, ad_editing, analysis, message, news,
  restaurant_editing, seat, setting, smoking_ng, smoking_ok, shop, search, question, takeout, reservation, homepage_settings, external_connect, course, link, post, menu, account_setting;

.icon {
  display: flex;
  width: 1em;
  height: 1em;
  align-items: center;
  justify-content: center;
  color: $color-navy-70;
  line-height: 1;

  &::before {
    display: block;
    flex: 0 0 auto;
  }

  @each $icon-name in $icon-names {
    &--#{$icon-name} {
      @include iconfont($icon-name);
    }
  }
}
</style>
